// extracted by mini-css-extract-plugin
export default {"div":"Card_div__K7ZFK","a":"Card_a__o0xd5","img":"Card_img__qzzNQ","span":"Card_span__YtQaE"};